import Placeholder from 'containers/placeholder-page/Placeholder';
import { FC } from 'react';

const PlaceholderPage: FC = () => {
  return <Placeholder />;
};

export default PlaceholderPage;
